import React from 'react';

export default (props) => {
    let {title, image, description} = props;
    return (
        <div>
            <div className="training-title">{title}</div>
            <img src={image} alt={title} />
            <p>{description}</p>
        </div>
    );
}